import { tracksService } from '../services/tracks';
import { tracksFormatter } from '../formatters/tracks';
import { errorActions } from './error';
import { youtubeConstants } from '../constants/youtube';
import { youtubeService } from '../services/youtube';
import { youtubeFormatter } from '../formatters/youtube';
import { find, map } from 'lodash';

export const youtubeActions = {
	getStreamsStats,
	getDemographicsStats,
	getTerritoryStats,
	getDemographicsTerritoryStats,
	getSourceStats,
	getSourceDiscoveryStats,
	getSourceTimeseries,
	getSourceDiscoveryTimeseries,
	getSourcePlaylists,
	getSourceDiscoveryPlaylists,    
	getDeviceStats,
	getPlaylistStats,
	getTopTracksStats,
	getRepeatListeners,
	getTopTracksTimeseries,
	getRepeatListenersRatio
};

function getStreamsStats(filtered, dateGroup) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(dateGroup) {
			filtered.push({
				id: 'date_grouping',
				value: dateGroup
			})
		}
		return youtubeService.getStreamsStats({filtered}, globalFilter)
			.then(
				youtube => {
					const data = youtubeFormatter.formatStreamsStats(youtube);
					dispatch(success(data, youtube));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_STREAMS_STATS_REQUEST } }
	function success(data, youtube) { return { type: youtubeConstants.GET_YOUTUBE_STREAMS_STATS_SUCCESS, data, youtube } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_STREAMS_STATS_FAILURE, error } }
}

function getDemographicsStats(id, entity, filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];
		const fields = 'age, gender, curr_units, passive, active';
		return youtubeService.getDemographicsStats({filtered}, globalFilter, fields)
			.then(
				youtube => {
					const data = youtubeFormatter.formatDemographicsStats(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_DEMOGRAPHICS_STATS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_DEMOGRAPHICS_STATS_SUCCESS, data} }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_DEMOGRAPHICS_STATS_FAILURE, error } }
}

function getTerritoryStats(filtered, sorted) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		return youtubeService.getTerritoryStats({filtered, sorted}, globalFilter)
			.then(
				youtube => {
					const data = youtubeFormatter.formatTerritoryStats(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_TERRITORY_STATS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_TERRITORY_STATS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_TERRITORY_STATS_FAILURE, error } }
}

function getDemographicsTerritoryStats(filtered, territory) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		
		filtered.push({
			id: 'territories',
			value: territory
		});
		const fields = 'age, gender, listeners, total_streams, active, passive';
		return youtubeService.getDemographicsTerritoryStats({filtered}, globalFilter, fields)
			.then(
				youtube => {
					const data = youtubeFormatter.formatDemographicsTerritoryStats(youtube);
					dispatch(success(data, territory));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_REQUEST } }
	function success(data, territory) { return { type: youtubeConstants.GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_SUCCESS, data, territory } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_DEMOGRAPHICS_TERRITORY_STATS_FAILURE, error } }
}


function getSourceStats(filtered, sorted) {
	return ( dispatch, getState ) => {
		dispatch(request());
		let globalFilter = Object.assign({}, getState().filter.global);
			
		return youtubeService.getSourceStats({filtered, sorted}, globalFilter)
			.then(tracks => {				
				const data = tracks = youtubeFormatter.formatSourceStats(tracks);
				dispatch(success(data));
				return data;
			})
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_STATS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_STATS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_STATS_FAILURE, error } }
}

function getSourceDiscoveryStats(id, entity, filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];
		const fields = 'source, listeners, total_streams';
		return youtubeService.getSourceStats({filtered}, globalFilter, true, fields)
			.then(
				youtube => {
					const data = youtubeFormatter.formatSourceStats(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_STATS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_STATS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_STATS_FAILURE, error } }
}

function getSourceTimeseries(filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(dateGroup) {
			filtered.push({
				id: 'date_grouping',
				value: dateGroup
			})
		}
		return youtubeService.getStreamsStats({filtered}, globalFilter)
			.then(
				youtube => {
					const data = youtubeFormatter.formatStreamsStats(youtube);
					dispatch(success(data, youtube));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_TIMESERIES_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_TIMESERIES_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_TIMESERIES_FAILURE, error } }
}

function getSourceDiscoveryTimeseries(id, entity, filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];

		return youtubeService.getSourceTimeseries({filtered}, globalFilter, true)
			.then(
				youtube => {
					const data = youtubeFormatter.formatSourceTimeseries(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_TIMESERIES_FAILURE, error } }
}

function getSourcePlaylists(id, entity, filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];

		return youtubeService.getSourcePlaylists({filtered}, globalFilter, false)
			.then(
				youtube => {
					const data = youtubeFormatter.formatSourcePlaylists(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_PLAYLISTS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_PLAYLISTS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_PLAYLISTS_FAILURE, error } }
}

function getSourceDiscoveryPlaylists(id, entity, filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];

		return youtubeService.getSourcePlaylists({filtered}, globalFilter, true)
			.then(
				youtube => {
					const data = youtubeFormatter.formatSourcePlaylists(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_SOURCE_DISCOVERY_PLAYLISTS_FAILURE, error } }
}


function getPlaylistStats(id, entity) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		return youtubeService.getPlaylistStats({filtered: [{
			id: entity,
			value: id
		}]}, globalFilter)
			.then(
				youtube => {
					const data = youtubeFormatter.formatPlaylistStats(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_PLAYLIST_STATS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_PLAYLIST_STATS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_PLAYLIST_STATS_FAILURE, error } }
}

function getTopTracksStats(filtered, sorted) {
	return ( dispatch, getState ) => {
		dispatch(request());
		let globalFilter = Object.assign({}, getState().filter.global);
			
		return youtubeService.getTopTracksStats({filtered, sorted}, globalFilter)
			.then(tracks => {				
				tracks = youtubeFormatter.formatTopTracksStats(tracks);
				const ids = map(tracks, (track)=>track.id);
				return tracksService.getMetadata(ids)
				.then(metadata => {
					const data = tracksFormatter.formatMetadata(tracks, metadata.data, [], globalFilter);
					dispatch(success(data));
					return data;
				});
			})
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_TOP_TRACKS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_TOP_TRACKS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_TOP_TRACKS_FAILURE, error } }
}

function getRepeatListeners(id, entity, filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];
		return youtubeService.getRepeatListeners({filtered}, globalFilter)
			.then(
				youtube => {
					const data = youtubeFormatter.formatRepeatListeners(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_REPEAT_LISTENERS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_REPEAT_LISTENERS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_REPEAT_LISTENERS_FAILURE, error } }
}

function getTopTracksTimeseries(filtered, sorted) {
	return ( dispatch, getState ) => {
		dispatch(request());
		let globalFilter = Object.assign({}, getState().filter.global);
			
		return youtubeService.getTopTracksTimeseries({filtered, sorted}, globalFilter)
			.then(tracks => {				
				
				const ids = map(tracks, (track)=>track.track_id);
				return tracksService.getMetadata(ids)
				.then(metadata => {
					const data = youtubeFormatter.formatTopTracksTimeseries(tracks, metadata.data);
					dispatch(success(data));
					return data;
				});
			})
	};


	function request() { return { type: youtubeConstants.GET_YOUTUBE_TOP_TRACKS_TIMESERIES_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_TOP_TRACKS_TIMESERIES_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_TOP_TRACKS_TIMESERIES_FAILURE, error } }
}

function getRepeatListenersRatio(id, entity, filtered, dateGroup) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];
		if(dateGroup) {
			filtered.push({
				id: 'date_grouping',
				value: dateGroup
			})
		}            
		return youtubeService.getRepeatListenersRatio({filtered}, globalFilter)
			.then(
				youtube => {
					const data = youtubeFormatter.formatRepeatListenersRatio(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_REPEAT_LISTENERS_RATIO_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_REPEAT_LISTENERS_RATIO_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_REPEAT_LISTENERS_RATIO_FAILURE, error } }
}

function getDeviceStats(id, entity, filtered) {
	return ( dispatch, getState ) => {
		dispatch(request());
		const globalFilter = getState().filter.global;
		if(filtered === undefined)
			filtered = [{
				id: entity,
				value: id
			}];
		const fields = 'device, listeners, total_streams';
		return youtubeService.getDeviceStats({filtered}, globalFilter, fields)
			.then(
				youtube => {
					const data = youtubeFormatter.formatDeviceStats(youtube);
					dispatch(success(data));
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: youtubeConstants.GET_YOUTUBE_DEVICE_STATS_REQUEST } }
	function success(data) { return { type: youtubeConstants.GET_YOUTUBE_DEVICE_STATS_SUCCESS, data } }
	function failure(error) { return { type: youtubeConstants.GET_YOUTUBE_DEVICE_STATS_FAILURE, error } }
}
